import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './imgs/logo.png';
import './Styles/Navbar.css';

export default function Navbar({ mode, toggleMode }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
        setIsOpen(false);
    };

    

    return (
        <nav className="navbar">
            {/* Logo Section */}
            <div className="logo">
                <Link to="/" onClick={closeMenu}>
                        <img src={logo} alt="logo" />
                </Link>
                    </div>

            {/* Hamburger Menu */}
            <button 
                className={`hamburger ${menuOpen ? 'active' : ''}`} 
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* Navigation Links */}
            <ul className={`nav-list1 ${menuOpen ? 'active' : ''}`}>
                <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                <li><Link to="/courses" onClick={closeMenu}>Courses</Link></li>
                <li>
                    <div className="dropdown">
                            <button onClick={toggleDropdown}>
                                Products <i className={`arrow ${isOpen ? 'up' : 'down'}`}></i>
                            </button>
                        {isOpen && (
                            <div className="dropdown-content">
                                    <Link to="/products" className='dropdown-item' onClick={closeMenu}>Embroidery</Link>
                                    <Link to="/productsC" className='dropdown-item' onClick={closeMenu}>Crochet</Link>
                                    <Link to="/productsK" className='dropdown-item' onClick={closeMenu}>Knitting</Link>
                            </div>
                        )}
                    </div>
                </li>
                <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
                <li><Link to="/feed" onClick={closeMenu}>Community</Link></li>
            </ul>        
        </nav>
    );
}
